const StringManager = {};

StringManager.install = function (Vue) {
  Vue.prototype.$getString = function (key) {
    return this.$store.getters.string(key);
  }
}

export default StringManager
